import { render, staticRenderFns } from "./AddStaffItem2.vue?vue&type=template&id=9e7b553e&scoped=true"
import script from "./AddStaffItem2.vue?vue&type=script&lang=js"
export * from "./AddStaffItem2.vue?vue&type=script&lang=js"
import style0 from "./AddStaffItem2.vue?vue&type=style&index=0&id=9e7b553e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7b553e",
  null
  
)

export default component.exports